import AppComponent from "./app";
import Init from "./init";
import "@/assets/index.scss";

function App() {
  return (
    <Init>
      <AppComponent />
    </Init>
  );
}

export default App;
